import { SISTEMA_GET, SistemaActionTypes, SISTEMAS_GET, SistemaState } from "domain/types/sistema/sistema"

const INITIAL_STATE: SistemaState = {
    sistema: undefined,
    sistemas: undefined
}

export function SistemaReducer(state = INITIAL_STATE, action: SistemaActionTypes): SistemaState {
    switch (action.type) {
        case SISTEMA_GET:
            return { ...state, sistema: action.payload }
        case SISTEMAS_GET:
            return { ...state, sistemas: action.payload }
        default:
            return state
    }
}